import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const CaseSingle = () => {

  // Get case study details passed via router state
  const location = useLocation();
  const caseStudy = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={caseStudy.title} page={"Case Single"} />

      <section className='case-single page-single'>

        <div className='case-info page-info'>

          {/* Case Study Image */}
          <div className='image'>
            <img src={caseStudy.image} alt={caseStudy.title} />
          </div>

          <div className='content'>

            {/* Case Study Title */}
            <h3 className='main-heading'>{caseStudy.title}</h3>

            {/* Case Study Description */}
            {caseStudy.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Case Study Image Gallery */}
            <Lightbox images={caseStudy.gallery} />

            {/* Project Challenges Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Challenges:</h3>
              <p>Challenges faced in {caseStudy.title}, including infrastructure limits, signal issues, and custom service needs:</p>

              {/* List of Project Challenges */}
              <ul>
                {caseStudy.challenges.map((challenge, index) => {
                  return <li key={index}>
                      <div className='icon'><FaCheck /></div>
                      {challenge}
                    </li>
                })}
              </ul>

            </div>

            {/* Project Solution Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Solutions:</h3>
              <p>We tackled each issue with smart strategies and expert execution, ensuring {caseStudy.title} was delivered successfully:</p>

              {/*Project Solutions List */}
              <ul>
                {caseStudy.solutions.map((solution, index) => {
                  return <li key={index}>
                    <div className='icon'><FaCaretRight /></div>
                    {solution}
                  </li>
                })}
              </ul>

            </div>

            {/* Project Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Results:</h3>
              <p>A quick summary of key achievements and client satisfaction from {caseStudy.title}:</p>

              {/* Project Results */}
              <ul>
                {caseStudy.results.map((result, index) => {
                  return <li key={index}>
                    <div className='icon'><FaCircleNotch /></div>
                    {result}
                  </li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Case Study details */}
        <PageSidebar
          heading={'Case Study'}
          details={caseStudy.details}
        />

      </section>

    </> 
  );
}

export default CaseSingle;